import { render, staticRenderFns } from "./ItemsModal.vue?vue&type=template&id=9643e1c6&scoped=true&"
import script from "./ItemsModal.vue?vue&type=script&lang=js&"
export * from "./ItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemsModal.vue?vue&type=style&index=0&id=9643e1c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9643e1c6",
  null
  
)

export default component.exports